import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';
import type { GetEbaseCandidateListRequest, GetEbaseCandidateListResponse } from '../../../app/kymw/kymw11/kymw1108/api-service/get-ebase-candidate-list.service';

export const kymw11Handlers = [
  // 候補リスト一覧取得 /kymw11/getCandidateGoodsList
  http.post(PlessService.SERVICE.KYMW11getCandidateGoodsList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW11getCandidateGoodsList.url, req);
    return HttpResponse.json(any);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品候補リストファイル出力 /kymw11/makeCandidateGoodsFile
  http.post(PlessService.SERVICE.KYMW11makeCandidateGoodsFile.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW11makeCandidateGoodsFile.url, req);
    return HttpResponse.json(makeCandidateGoodsFileResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // コープ商品URL取込 /kymw11/updateCoopGoodsUrlData
  http.post(PlessService.SERVICE.updateCoopGoodsUrlData.url, async ({ request }) => {
    const req = await new FormData();
    console.log(PlessService.SERVICE.updateCoopGoodsUrlData.url, req);
    return HttpResponse.json(updateCoopGoodsUrlDataResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 旧商品タグ情報取得 /kymw11/getOldGoodsTagList
  http.post(PlessService.SERVICE.getOldGoodsTagList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getOldGoodsTagList.url, req);
    return HttpResponse.json(getOldGoodsTagListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // タグ情報取得 /kymw11/getTagInfo
  http.post(PlessService.SERVICE.getTagInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getTagInfo.url, req);
    return HttpResponse.json(getTagInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 掲載媒体情報取得 /kymw11/getPublishMediumInfo
  http.post(PlessService.SERVICE.KYMW11getPublishMediumInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW11getPublishMediumInfo.url, req);
    return HttpResponse.json(getPublishMediumInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // コープ商品URL取得 /kymw11/getCoopGoodsUrlData
  http.post(PlessService.SERVICE.getCoopGoodsUrlData.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getCoopGoodsUrlData.url, req);
    return HttpResponse.json(getCoopGoodsUrlDataResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品ECカテゴリ情報リストを取得 /kymw11/getEcCategory
  http.post(PlessService.SERVICE.getEcCategory.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getEcCategory.url, req);
    return HttpResponse.json(geEcCategoryResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品情報更新 /kymw11/updateGoods
  http.post(PlessService.SERVICE.updateGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateGoods.url, req);
    return HttpResponse.json(updateGoodsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品情報登録 /kymw11/registGoods
  http.post(PlessService.SERVICE.registGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.registGoods.url, req);
    return HttpResponse.json(registGoodsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // ※動作確認用 商品コピー /kymw11/registGoodsBaseCopy
  http.post(PlessService.SERVICE.registGoodsBaseCopy.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.registGoodsBaseCopy.url, req);
    return HttpResponse.json(registGoodsBaseCopy);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),


  // eBASE取込データ作成 /kymw11/createEBaseData
  http.post(PlessService.SERVICE.createEBaseData.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.createEBaseData.url, req);
    // 新規登録商品データをセット
    createEBaseDataResponse.result.obj.EbaseListGoodsInfo.push({CaEbaseSpecCode: "C9354843-0UVT0X7Q-00000000", GuideGoodsName: "新規商品名1", GuideStandardName: "規格名1", JanCode: "1234567890001", FixContainNum: "12", MakerName: "メーカー名1", LinkedPcode: "P1234567", LinkedItemCode: "1234567", ProcessFlag: "0"});
    createEBaseDataResponse.result.obj.EbaseListGoodsInfo.push({CaEbaseSpecCode: "C9354843-0UVT0X7Q-00000000", GuideGoodsName: "新規商品名2", GuideStandardName: "規格名1", JanCode: "1234567890002", FixContainNum: "12", MakerName: "メーカー名1", LinkedPcode: "P1234567", LinkedItemCode: "1234567", ProcessFlag: "0"});
    // // 更新対象1件の商品データをセット
    createEBaseDataResponse.result.obj.EbaseListGoodsInfo.push({CaEbaseSpecCode: "C9354843-0UVT0X7Q-11111111", GuideGoodsName: "更新商品名1", GuideStandardName: "規格名1", JanCode: "1234567890011", FixContainNum: "12", MakerName: "メーカー名1", LinkedPcode: "P1234567", LinkedItemCode: "1234567", ProcessFlag: "1"});
    createEBaseDataResponse.result.obj.EbaseListGoodsInfo.push({CaEbaseSpecCode: "C9354843-0UVT0X7Q-11111111", GuideGoodsName: "更新商品名2", GuideStandardName: "規格名1", JanCode: "1234567890012", FixContainNum: "12", MakerName: "メーカー名1", LinkedPcode: "P1234567", LinkedItemCode: "1234567", ProcessFlag: "1"});
    // // 取引先選択が必要な商品データをセット
    createEBaseDataResponse.result.obj.EbaseListGoodsInfo.push({CaEbaseSpecCode: "C9354843-0UVT0X7Q-0UVT0X7Q", GuideGoodsName: "取引先選択商品名1", GuideStandardName: "規格名1", JanCode: "1234567890021", FixContainNum: "11", MakerName: "メーカー名1", LinkedPcode: "P1234501", LinkedItemCode: "1111111", ProcessFlag: "2"});
    createEBaseDataResponse.result.obj.EbaseListGoodsInfo.push({CaEbaseSpecCode: "C9354843-0UVT0X7Q-0AB70X9Z", GuideGoodsName: "取引先選択商品名2", GuideStandardName: "規格名1", JanCode: "1234567890022", FixContainNum: "14", MakerName: "メーカー名4", LinkedPcode: "P1234504", LinkedItemCode: "4444444", ProcessFlag: "2"});
    createEBaseDataResponse.result.obj.EbaseListGoodsInfo.push({CaEbaseSpecCode: "C9354843-0UVT0X7Q-5GPT0X7R", GuideGoodsName: "取引先選択商品名3", GuideStandardName: "規格名1", JanCode: "1234567890023", FixContainNum: "17", MakerName: "メーカー名7", LinkedPcode: "P1234507", LinkedItemCode: "7777777", ProcessFlag: "2"});
    return HttpResponse.json(createEBaseDataResponse);
  }),

  // eBASE一括取込 /kymw11/updateEBaseData
  http.post(PlessService.SERVICE.updateEBaseData.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateEBaseData.url, req);
    return HttpResponse.json(updateEBaseDataResponse);
  }),

  // eBASE取込商品候補一覧取得 /kymw11/getEbaseCandidateList
  http.post(PlessService.SERVICE.getEbaseCandidateList.url, async ({ request }) => {
    const req = await request.json() as { data: GetEbaseCandidateListRequest };
    console.log(PlessService.SERVICE.registGoods.url, req);

    const janCode = req.data.parameter.JanCode;
    const listLength = 10;
    const list = Array.from({ length: listLength }, (_, index) => (
      {
        PCode: `P${(index + 1).toString().padStart(7, '0')}`, // 「P＋ゼロ埋め7桁番号」
        ItemCode: janCode.slice(-2) + (index + 1).toString().padStart(5, '0'), // JANコード末尾2桁＋ゼロ埋め5桁連番
        JanCode: janCode,
        GoodsName: `商品名${(index + 1)}`,
        StandardName: `規格名${(index + 1)}`,
        ContainNum: Math.floor(Math.random() * 20) + 1, // 1 ~ 20 ランダムな整数
        EBaseSpecCode: "C111111-22223333-44445555",
        UpdateDate: "2025/06/05",
      }
    ));
    getEbaseCandidateListResponse.result.obj.GoodInfoList = list;

    return HttpResponse.json(getEbaseCandidateListResponse);
  }),

  // 新規取扱情報帳票出力日更新 /kymw11/updateReportOutputDate
  http.post(PlessService.SERVICE.updateReportOutputDate.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateReportOutputDate.url, req);
    return ResponseUtils.getSuccess();
  }),
];

const any = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TotalNum: 5,
      StartDispNum: 1,
      EndDispNum: 5,
      CandidateGoodsList: [
        {
          Pcode: 'P0001082',
          GuideGoodsName: '青首大根',
          GuideStandardName: '１本',
          LatestOrderCode: '2023290',
          LatestDelivCatalogId: '20231001',
          FirstOrderCode: '2023250',
          FirstDelivCatalogId: '20230901',
          HandlingCoop1: '●',
          HandlingCoop2: '●',
          HandlingCoop3: '●',
          HandlingCoop4: '●',
          HandlingCoop5: '●',
          HandlingCoop6: '●',
          HandlingCoop7: '●',
          HandlingCoop8: '●',
          RegistDate: '1995/12/01',
          UpdateDate: '2024/07/18',
          DataKbn: '0'
        },
        {
          Pcode: 'P0003247',
          GuideGoodsName: '青首大根２',
          GuideStandardName: '２本',
          LatestOrderCode: '2023300',
          LatestDelivCatalogId: '20231002',
          FirstOrderCode: '2023260',
          FirstDelivCatalogId: '20230902',
          HandlingCoop1: '●',
          HandlingCoop2: '●',
          HandlingCoop3: '●',
          HandlingCoop4: '●',
          HandlingCoop5: '',
          HandlingCoop6: '',
          HandlingCoop7: '',
          HandlingCoop8: '',
          RegistDate: '1995/12/02',
          UpdateDate: '2024/07/19',
          DataKbn: '0'
        },
        {
          Pcode: 'P1199536',
          GuideGoodsName: '青首大根３',
          GuideStandardName: '３本',
          LatestOrderCode: '2023310',
          LatestDelivCatalogId: '20231003',
          FirstOrderCode: '2023270',
          FirstDelivCatalogId: '20230903',
          HandlingCoop1: '●',
          HandlingCoop2: '●',
          HandlingCoop3: '●',
          HandlingCoop4: '●',
          HandlingCoop5: '●',
          HandlingCoop6: '●',
          HandlingCoop7: '●',
          HandlingCoop8: '●',
          RegistDate: '1995/12/01',
          UpdateDate: '2024/07/18',
          DataKbn: '1'
        },
        {
          Pcode: 'P2269805',
          GuideGoodsName: '青首大根４',
          GuideStandardName: '４本',
          LatestOrderCode: '2023310',
          LatestDelivCatalogId: '20231003',
          FirstOrderCode: '2023270',
          FirstDelivCatalogId: '20230903',
          HandlingCoop1: '',
          HandlingCoop2: '',
          HandlingCoop3: '',
          HandlingCoop4: '●',
          HandlingCoop5: '',
          HandlingCoop6: '',
          HandlingCoop7: '',
          HandlingCoop8: '',
          RegistDate: '1995/12/01',
          UpdateDate: '2024/07/18',
          DataKbn: '1'
        },
        {
          Pcode: 'P2508171',
          GuideGoodsName: '青首大根５',
          GuideStandardName: '５本',
          LatestOrderCode: '2023310',
          LatestDelivCatalogId: '20231003',
          FirstOrderCode: '2023270',
          FirstDelivCatalogId: '20230903',
          HandlingCoop1: '●',
          HandlingCoop2: '●',
          HandlingCoop3: '●',
          HandlingCoop4: '●',
          HandlingCoop5: '●',
          HandlingCoop6: '●',
          HandlingCoop7: '●',
          HandlingCoop8: '●',
          RegistDate: '1995/12/01',
          UpdateDate: '2024/07/18',
          DataKbn: '2'
        },
      ],
    },
  },
};

const makeCandidateGoodsFileResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      FileUrl: '/tmp/peace/data/WebData/downloadtemp/candidateGoods_20240725.txt',
    },
  },
};

const updateCoopGoodsUrlDataResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      NormalNum: 1,
      AttentionNum: 0,
      AbnormalNum: 0,
      UpdateNum: 1,
      ManageNum: 1
    },
  },
};

const getOldGoodsTagListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TagList: [
        {
          TagInfo: {
            TagGroupId: '00000001',
            TagGroupName: 'タググループ１',
            TagId: '00000001',
            TagName: 'タグ１'
          }
        },
        {
          TagInfo: {
            TagGroupId: '00000001',
            TagGroupName: 'タググループ１',
            TagId: '00000002',
            TagName: 'タグ２'
          }
        },
        {
          TagInfo: {
            TagGroupId: '00000002',
            TagGroupName: 'タググループ２',
            TagId: '00000003',
            TagName: 'タグ３'
          }
        },
      ]
    },
  },
};

const getTagInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TagList: {
        TagInfo: [
          {
            TagGroupId: "00000001",
            TagGroupName: "夏",
            TagId: "00000002",
            TagName: "夏祭り"
          }
        ]
      }
    },
  },
};

const getPublishMediumInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      MediumList: {
        MediumInfo: [
          {
            MediumType: "001",
            MediumName: "ハピデリ"
          }
        ]
      }
    },
  },
};

const getCoopGoodsUrlDataResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CoopGoodsTitle: 'コープ商品タイトル',
      CoopGoodsUrl: 'コープ商品URL',
    },
  },
};

const geEcCategoryResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CategoryList: [
        {
          CategoryCode: '001',
          CategoryName: 'カテゴリ１',
        },
        {
          CategoryCode: '002',
          CategoryName: 'カテゴリ２',
        },
        {
          CategoryCode: '003',
          CategoryName: 'カテゴリ３',
        },
      ]
    },
  },
};

const updateGoodsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      ItemCode: '0001929',
      UpdateDate: '2024/07/29 15:09:43',
      RegistDate: '1995/12/01 00:00:00',
      ItemList: {
        List: [
            {
                "ItemCode": "0001929"
            }
        ]
      },
      JanCodeDuplicateFlag: '0'
    },
  },
};

const registGoodsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      PCode: 'P2675388',
      ItemCode: '0001929',
      UpdateDate: '2024/07/29 15:09:43',
      RegistDate: '1995/12/01 00:00:00',
      ItemList: {
        List: [
            {
                "ItemCode": "0001929"
            }
        ]
      },
      GoodsNameExactMatchFlag: '0',
      JanCodeDuplicateFlag: '0'
    },
  },
};

const createEBaseDataResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: { EbaseListGoodsInfo: [] },
  }
};

const updateEBaseDataResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      NormalNum: 1,
      AttentionNum: 0,
      AbnormalNum: 0,
      UpdateNum: 1,
      ManageNum: 1,
    },
  }
};

const getEbaseCandidateListResponse: {
  status: string;
  message: string;
  result: { obj: GetEbaseCandidateListResponse }
} = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: { GoodInfoList: [] },
  }
};

const registGoodsBaseCopy = {
  status: "ok",
  message: "処理完了",
  result: {
    obj: {
      GoodsBaseData: {
        PCode: "P2694030",
        BuyerCode: "00100001",
        ClassDivNum: 2,
        ClassCode: "01",
        LargeClassCode: "01",
        MiddleClassCode: "0100",
        SmallClassCode: "010000",
        AdmitStatus: "1",
        PackMaterialShowFlg: "0",
        DataType: "00",
        ApplyTermStart: "19951201",
        ApplyTermEnd: "99999999",
        GuideGoodsName: "グリーンハウスみかん",
        GuideStandardName: "４００ｇ（４～６個）",
        DeliveryGoodsNameKanji: "グリーンハウスみかん",
        DeliveryGoodsNameKana: "ｸﾞﾘ-ﾝﾊｳｽ ﾐｶﾝ",
        DeliveryStandardNameKanji: "４００ｇ（４～６個）",
        DeliveryStandardNameKana: "400G(4-6)",
        OcrGoodsName: "みかんグリーンハ",
        ConsumeTaxDiv: "0",
        ConsumeTaxDivWk: "",
        ConsumeTaxRate: 8,
        ConsumeTaxRateWk: null,
        CycleTerm: "",
        EdlpDiv: "0",
        GuideTempZoneDiv: "",
        UnitPriceDiv: "0",
        UnitPriceCoefficient: 0,
        UnitPriceUnit: "",
        ConsumeTerm: 0,
        ConsumeByDate: 0,
        LeaveConsumeTerm: 0,
        SeasonConsumeDiv: "0",
        SeasonConsumeTerm: 0,
        SeasonConsumeTermFrom: "",
        SeasonConsumeTermTo: "",
        RelationPcodeOld: "",
        RelationPcodeNew: "",
        BlindDiv: "",
        EFriendsSendDiv: "0",
        EcNonDispDiv: "1",
        LiquorCode: "",
        AlocoholType: 0,
        ContainerForm: "",
        ContainerCapacity: 0,
        StinkGoodsDiv: "0",
        SetDiv: "0",
        CaseSupplyDiv: "0",
        LongKeepDiv: "0",
        AssortTempdiv: "03",
        ArrivalAreaDiv: "00",
        ArrivalGoodsTemp: 10,
        ArrivalAdminDays: 1,
        ListingGoodsName: "",
        GoodsDiv: "0",
        CategoryCode: "001",
        DutiesFormDailyDiv: "00",
        FragileFlg: "0",
        CoopGoodsTitle: "",
        CoopGoodsUrl: "",
        PageTitle: "",
        PageUrl: ""
      },
      MarkCodeList: {
        List: [
          {
            MarkCode: 27
          }
        ]
      },
      TextInfoList: {
        List: [
          {
            TextKindID: "001",
            StringValue: "直前の気温により着色（黄色に）が進む場合あり。"
          },
          {
            TextKindID: "035",
            StringValue: "６カ月頃から"
          }
        ]
      },
      TextInfoCountList: {
        List: [
          {
            TextInfoCnt: "1",
            TextKindID: "001"
          },
          {
            TextInfoCnt: "0",
            TextKindID: "003"
          },
        ]
      },
      GoodsListingList: {
        List: []
      },
      GoodsDnaInfoList: {
        List: []
      },
      GoodsDetail: {
        ItemCode: "4686500",
        BrandType: "04",
        BundlePrice: 1,
        FcmcFee: 0,
        SpecialOrderType: "00",
        StockType: "1",
        InstallmentTimes: 1,
        PdPilingUpDays: 1,
        PriceType: "",
        ItfCode: "",
        OrderUnitType: "0",
        MakerPrice: 0,
        OrderClientCode: "947385",
        OrderClientName: "コープネット農産",
        OrderTradeStopDiv: "0       ",
        PayeeClientCode: "947385",
        PayeeClientName: "コープネット農産",
        PayeeTradeStopDiv: "0       ",
        FixContainNum: 1,
        SetQuantity: 1,
        EbaseSpecCode: "",
        SpecApplyDate: "",
        RegistCatalogRound: "",
        MakerName: "",
        MakerNamePublishType: "1",
        PeaceSizeLength: 1,
        PeaceSizeWidth: 1,
        PeaceSizeHight: 1,
        PeaceWeight: 1000,
        CaseSizeLength: 1,
        CaseSizeWidth: 1,
        CaseSizeHight: 1,
        CaseWeight: 1,
        AllergenTargetType: "1",
        AnalysisUnit: "",
        Calorie: null,
        Protein: "",
        Lipid: "",
        Carbohydrate: "",
        Sodium: "",
        GeneRecombinationDiv: "0",
        EbaseGetDate: "",
        EbaseSpecCodeRev: "",
        UpdateDate: "",
        RegistDate: "2025/08/24 12:55:05",
        JANCode: "0400000001982",
        JANCodeDiv: "0"
      },
      GoodsCoopList: {
        List: [
          {
            CoopCode: "142",
            SupplyPriceStandard: 498,
            SupplyPriceSpecial1: 450,
            SupplyPriceSpecial2: 398,
            CostPriceStandard: 365,
            CostPriceSpecial1: 365,
            CostPriceSpecial2: 365,
            ConsignPriceStandard: 365.00,
            ConsignPriceSpecial1: 365.00,
            ConsignPriceSpecial2: 365.00,
            ProducingAreaComment1: "★★★★★★★★★★",
            ProducingAreaComment2: "★★★★★★★★★★"
          },
          {
            CoopCode: "163",
            SupplyPriceStandard: 498,
            SupplyPriceSpecial1: 450,
            SupplyPriceSpecial2: 398,
            CostPriceStandard: 365,
            CostPriceSpecial1: 365,
            CostPriceSpecial2: 365,
            ConsignPriceStandard: 365.00,
            ConsignPriceSpecial1: 365.00,
            ConsignPriceSpecial2: 365.00,
            ProducingAreaComment1: "★★★★★★★★★★",
            ProducingAreaComment2: "★★★★★★★★★★"
          },
          {
            CoopCode: "185",
            SupplyPriceStandard: 498,
            SupplyPriceSpecial1: 450,
            SupplyPriceSpecial2: 398,
            CostPriceStandard: 365,
            CostPriceSpecial1: 365,
            CostPriceSpecial2: 365,
            ConsignPriceStandard: 365.00,
            ConsignPriceSpecial1: 365.00,
            ConsignPriceSpecial2: 365.00,
            ProducingAreaComment1: "★★★★★★★★★★",
            ProducingAreaComment2: "★★★★★★★★★★"
          },
        ]
      },
      GoodsCoopWkList: {
        List: []
      },
      Specifications1List: {
        List: []
      },
      GoodsAllergenList: {
        List: []
      },
      GoodsEcologyList: {
        List: [
          {
            EcologyDiv: "00"
          }
        ]
      },
      GoodsGwstopList: {
        List: []
      },
      ContainPackingList: {
        List: []
      },
      ItemList: {
        List: [
          {
            ItemCode: "4686500"
          }
        ]
      },
      GoodsComponentAllergenList: {
        List: []
      },
      NutrientInfoList: {
        List: []
      },
      NutrientInfoListMulti: {
        List: []
      },
      MediumList: {
        MediumInfo: [
          {
            MediumType: "001",
            MediumName: "medium1"
          },{
            MediumType: "002",
            MediumName: "medium2"
          }
        ]
      },
      TagList: {
        TagInfo: [
          {
            TagGroupId: "0000001",
            TagGroupName: "tagugroup1",
            TagId: "0000001",
            TagName: "tag1"
          },
          {
            TagGroupId: "0000002",
            TagGroupName: "tagugroup2",
            TagId: "0000002",
            TagName: "tag2"
          }
        ]
      },
      ConsumeTaxList: {
        ConsumeTaxInfo: [
          {
          ConsumeTaxDiv: "0 ",
          ConsumeTaxRate: 8
          },
          {
          ConsumeTaxDiv: "0 ",
          ConsumeTaxRate: 8
          }
        ]
      }
    }
  }
};